import React,{useState} from "react";
import Kull from "./Kull";
import Barnebarn from "./Barnebarn";
import icons from "../helpers/icons";


const Avkom = (props) => {
    const {antallKull, antallKullUnderBehandling, avkom, barnebarn } = props;

    const [expandAll,setExpandAll] = useState(false);
    const [collapseAll,setCollapseAll] = useState(false);
    const rows = avkom.map((kull) => (
        <Kull key={kull.kullId} kull={kull} expandAll = {expandAll} setExpandAll = {setExpandAll}
              collapseAll={collapseAll} setCollapseAll={setCollapseAll} />
    ));

    function toggleCollapse(){
        setExpandAll(!expandAll);
        setCollapseAll(true)
    }

    return (
        <div>
            <div className="splitt-title" onClick={()=>{toggleCollapse()}}>
                <div className="oppsummering">
                    <div className={"flex-row"}>
                        <div>
                            <span>Kuld: </span> {antallKull}
                            <span>Igangværende :</span> {antallKullUnderBehandling}
                        </div>
                        <span><img src={icons.acdw} alt="" data-open={expandAll}/></span>
                    </div>
                </div>
            </div>
            {avkom.length > 0 && rows}
            {avkom.length === 0 &&
                <div>&nbsp;</div>
            }
            <Barnebarn barnebarn={barnebarn} />

        </div>
    );
};

export default Avkom;
